import theme from '@styles/theme';
import { TMarginsTypes } from '@features/cms/typescript';
export default {
  section: (bg?: string, mt?: TMarginsTypes | undefined, mb?: TMarginsTypes | undefined) => ({
    width: '100%',
    bg,
    mt: mt ? `${mt}px` : 0,
    mb: mb ? `${mb}px` : 0,
    ml: '2px',
    mr: '2px'
  }),
  wrapper: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: ['repeat(1, minmax(0, 1fr))', 'repeat(1, minmax(0, 1fr))', 'repeat(2, minmax(0, 1fr))', 'repeat(3, minmax(0, 1fr))', 'repeat(4, minmax(0, 1fr))'],
    gridTemplateRows: 'repeat(auto-fill, minmax(0, 1fr))'
  },
  separator: {
    height: '1px',
    width: '100%',
    bg: theme.rawColors.lightGrey500,
    gridColumn: ['1 / 2', '1 / ', '1 / 3', '1 / 4', '1 / 5']
  },
  containerButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    m: 24
  }
};